import {
  PAYOFF_PARTICIPATION_UPSIDE_EARLY_TERMINATION,
  PAYOFF_PARTICIPATION_UPSIDE_REBATE_SETTLEMENT_LAG,
  SUMMARY_PRODUCT_TYPE,
} from './product-capture-field-selectors.consts';

import { FCSelector } from '../../model/form-config.interface';

export const REBATE_DATE: FCSelector = {
  formControlNames: [PAYOFF_PARTICIPATION_UPSIDE_EARLY_TERMINATION],
  options: [
    {
      id: true,
      effects: [
        {
          formControlNames: [PAYOFF_PARTICIPATION_UPSIDE_REBATE_SETTLEMENT_LAG],
          hidden: false,
        },
      ],
      concatFieldRules: [
        {
          formControlNames: [SUMMARY_PRODUCT_TYPE],
          options: [
            {
              id: 'WARRANT',
              effects: [
                {
                  formControlNames: [
                    PAYOFF_PARTICIPATION_UPSIDE_REBATE_SETTLEMENT_LAG,
                  ],
                  hidden: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: false,
      effects: [
        {
          formControlNames: [PAYOFF_PARTICIPATION_UPSIDE_REBATE_SETTLEMENT_LAG],
          hidden: true,
        },
      ],
    },
    {
      id: null,
      effects: [
        {
          formControlNames: [PAYOFF_PARTICIPATION_UPSIDE_REBATE_SETTLEMENT_LAG],
          hidden: true,
        },
      ],
    },
    {
      id: '',
      effects: [
        {
          formControlNames: [PAYOFF_PARTICIPATION_UPSIDE_REBATE_SETTLEMENT_LAG],
          hidden: true,
        },
      ],
    },
  ],
};
